import * as React from 'react';

import PropTypes from 'prop-types';

import {getRandomInt} from '../utils/numbers';

import styles from './list-row-loading.module.css';

export class ListRowLoading extends React.PureComponent {
    static propTypes = {
        style: PropTypes.object,
    };

    constructor(props) {
        super(props);
        this.topLineWidth = getRandomInt(50, 70);
        this.bottomLineWidth = getRandomInt(30, 60);
    }

    render() {
        return (
            <div style={this.props.style} className={styles.container}>
                <div className={styles['left-column']}>
                    <div className={styles['left-container']}>
                        <div className={styles.checkbox} />
                    </div>
                    <div className={styles['item-container']}>
                        <div
                            style={{width: `${this.topLineWidth}%`}}
                            className={styles['top-line']}
                        />
                        <div
                            style={{width: `${this.bottomLineWidth}%`}}
                            className={styles['bottom-line']}
                        />
                    </div>
                </div>
                <div className={styles['right-column']}>
                    <div className={styles.timestamp} />
                </div>
            </div>
        );
    }
}
